/**
 * Layout.js
 *
 * Route wrapper for the public "share event" feature. Keeps routing
 * concerns minimal — all UI/logic lives in src/features/share-event.
 */
import React from 'react';
import { ShareEventPage } from '@/features/share-event';

export default function Layout() {
  return <ShareEventPage />;
}
